import { render, staticRenderFns } from "./AddMaterial.vue?vue&type=template&id=f6ce4ce2&"
import script from "./AddMaterial.vue?vue&type=script&lang=js&"
export * from "./AddMaterial.vue?vue&type=script&lang=js&"
import style0 from "./AddMaterial.vue?vue&type=style&index=0&id=f6ce4ce2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports